import { isAdminImpersonating } from 'src/utils/impersonation';

/**
 * Subscription management is locked for "PayPal-on-source-account" customers
 * (migrated customers whose PayPal payment method lives on a different Stripe
 * account). Admins impersonating a user are exempt so support keeps full control.
 */
export default function isSubscriptionManagementLocked(
  subscription: { isPaypalSubscription?: boolean | null } | null | undefined,
): boolean {
  return Boolean(subscription?.isPaypalSubscription) && !isAdminImpersonating();
}
